(() => {
  'use strict';
  const previewSimulation = document.body.dataset.lnDemo === 'true' && !!document.querySelector('body > .ln2-prototype-banner');
  const pad = number => String(number).padStart(2, '0');
  const remaining = deadline => Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
  const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, String(value)); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const campaign = document.querySelector('[data-campaign-countdown]');
  const campaignEnds = document.querySelector('[data-campaign-ends]');
  const romeClock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  const romeParts = timestamp => Object.fromEntries(romeClock.formatToParts(timestamp).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const nextRomeMidnight = timestamp => {
    const today = romeParts(timestamp);
    const midnight = Date.UTC(today.year, today.month - 1, today.day + 1);
    let deadline = midnight;
    for (let attempt = 0; attempt < 3; attempt++) {
      const observed = romeParts(deadline);
      const correction = midnight - Date.UTC(observed.year, observed.month - 1, observed.day, observed.hour, observed.minute, observed.second);
      deadline += correction;
      if (!correction) break;
    }
    return deadline;
  };
  if (campaign && campaignEnds) campaignEnds.textContent = campaign.dataset.resetLabel || '';
  const stock = previewSimulation ? document.querySelector('[data-preview-stock]') : null;
  if (stock) {
    const handle = new URLSearchParams(location.search).get('item') || document.querySelector('[data-product-root]')?.dataset.defaultHandle || location.pathname;
    const key = `lunea-preview-stock:${handle}`;
    const saved = Number(read(key));
    const quantity = saved === 8 || saved === 9 ? saved : 8 + Math.floor(Math.random() * 2);
    write(key, quantity);
    stock.querySelector('[data-stock-number]').textContent = quantity;
    stock.hidden = false;
  }
  const cart = document.querySelector('#Ln2Cart');
  const reservation = previewSimulation ? cart?.querySelector('[data-cart-reservation]') : null;
  const reservationLabel = reservation?.querySelector('[data-reservation-label]');
  const reservationClock = reservation?.querySelector('[data-reservation-clock]');
  const reservationKey = 'lunea-preview-cart-reserved-until-v1';
  const storedDeadline = reservation ? Number(read(reservationKey)) : 0;
  let reservationDeadline = Number.isFinite(storedDeadline) && storedDeadline > 0 ? storedDeadline : 0;
  const renderReservation = () => {
    if (!reservation || reservation.hidden || !reservationDeadline) return;
    const seconds = remaining(reservationDeadline);
    reservationClock.textContent = `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
    reservationLabel.textContent = seconds ? reservation.dataset.activeLabel : reservation.dataset.expiredLabel;
    reservation.dataset.expired = String(seconds === 0);
  };
  const syncReservation = () => {
    if (!reservation || !cart.open) return;
    const hasItems = !!cart.querySelector('[data-cart-lines] .ln2-cart-line');
    reservation.hidden = !hasItems;
    if (!hasItems) {
      reservationDeadline = 0;
      remove(reservationKey);
      return;
    }
    if (!reservationDeadline) {
      reservationDeadline = Date.now() + 10 * 60 * 1000;
      write(reservationKey, reservationDeadline);
    }
    renderReservation();
  };
  if (cart && reservation) {
    new MutationObserver(syncReservation).observe(cart, { attributes: true, attributeFilter: ['open'] });
    const lines = cart.querySelector('[data-cart-lines]');
    if (lines) new MutationObserver(syncReservation).observe(lines, { childList: true });
    syncReservation();
  }
  const tick = () => {
    if (campaign) {
      const now = Date.now();
      const seconds = Math.ceil((nextRomeMidnight(now) - now) / 1000);
      campaign.querySelector('[data-count-hours]').textContent = pad(Math.floor(seconds / 3600));
      campaign.querySelector('[data-count-minutes]').textContent = pad(Math.floor((seconds % 3600) / 60));
      campaign.querySelector('[data-count-seconds]').textContent = pad(seconds % 60);
    }
    renderReservation();
  };
  tick();
  window.setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
})();

